import { render, staticRenderFns } from "./HomeBottomBanner.vue?vue&type=template&id=70eb1d12&scoped=true&"
import script from "./HomeBottomBanner.vue?vue&type=script&lang=js&"
export * from "./HomeBottomBanner.vue?vue&type=script&lang=js&"
import style0 from "./HomeBottomBanner.vue?vue&type=style&index=0&id=70eb1d12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb1d12",
  null
  
)

export default component.exports